import { Component, Input } from '@angular/core';
import { PageHeaderComponent } from '../../../../core/labels/page-header.component';
import { TabComponent } from '../../../../core/panels/tab-panel/tab.component';
import { TabPanelComponent } from '../../../../core/panels/tab-panel/tab-panel.component';
import { PolicyAttributesComponent } from '../../../policy-details/policy-attributes.component';
import { PolicyParticipantsComponent } from '../participants/participants.component';
import { RiskUnitDetailComponent } from './risk-unit-detail.component';
import { RiskUnitClassCodeComponent } from './risk-unit-class-code.component';
import { RiskUnitVehicleComponent } from './risk-unit-vehicle.component';
import { RiskUnitItemsComponent } from './risk-unit-items/risk-unit-items.component';

@Component({
  selector: 'app-risk-unit',
  imports: [
    PageHeaderComponent,
    TabComponent,
    TabPanelComponent,
    PolicyAttributesComponent,
    PolicyParticipantsComponent,
    RiskUnitDetailComponent,
    RiskUnitClassCodeComponent,
    RiskUnitVehicleComponent,
    RiskUnitItemsComponent,
  ],
  template: `@for (item of dataSource; track item) {
    <app-page-header
      [label]="item.riskUnitId"
      labelCase="none"
      class="tw-font-bold"
    />
    <app-tab-panel>
      <app-tab label="Detail">
        <ng-template #content>
          <app-risk-unit-detail [dataSource]="item.details" />
        </ng-template>
      </app-tab>
      <app-tab label="Attributes" [count]="item.attributes.length">
        <ng-template #content>
          <app-policy-attributes
            [dataSource]="item.attributes"
            [showEmpty]="true"
            [source]="lineOfBusiness"
            layout="policy"
          />
        </ng-template>
      </app-tab>
      <app-tab label="Class Codes" [count]="item.classCodes.length">
        <ng-template #content>
          <app-risk-unit-class-code [dataSource]="item.classCodes" />
        </ng-template>
      </app-tab>
      <app-tab label="Vehicles" [count]="item.vehicles.length">
        <ng-template #content>
          <app-risk-unit-vehicle [dataSource]="item.vehicles" />
        </ng-template>
      </app-tab>
      <app-tab label="Items" [count]="item.items.length">
        <ng-template #content>
          <app-risk-unit-items
            [dataSource]="item.items"
            [lineOfBusiness]="lineOfBusiness"
          />
        </ng-template>
      </app-tab>
      <app-tab label="Participants" [count]="item.participants.length">
        <ng-template #content>
          <app-participants [dataSource]="item.participants" />
        </ng-template>
      </app-tab>
    </app-tab-panel>
  }`,
  styles: [],
})
export class PolicyRiskUnitComponent {
  @Input() dataSource: any;
  @Input() lineOfBusiness: string;
}
